module.exports = __webpack_public_path__ + "static/media/main idea.dc8b2d33.mp3";